/* 🚀 Cells Bridge Configuration */
(function() {
  'use strict';

  window.CellsPolymer.start({
    /* ⛩ Application routes */
    routes: window.AppConfig.routes,
    /**
     * Router interceptor (Available in Cells Bridge 3.17.0).
     * Can use to stop a navigation or redirect based on its business logic.
     *
     * @param navigation
     * @param ctx - Context
     * @returns {{redirect: {}, intercept: boolean}}
     */
    interceptor: function({ from, to }, ctx) {
      let intercept = false;
      let redirect = {};

      if (!ctx.contextInitialized && to.page !== 'web-app-start' && to.page !== 'error') {
        intercept = true;
        redirect = { page: 'web-app-start', params: {} };
      }

      // El usuario recargo la aplicación
      if (from.page === 'error' && to.page === 'web-app-start') {
        window.location.reload();
      }

      return { intercept, redirect };
    },
    /**
     * @param template
     * @override
     * @see app-bootstrap.js into cells-app-template.
     */
    onRender(template) {
      if (!template.parentNode) {
        document.getElementById(this.mainNode).appendChild(template);
        if (template.name !== 'web-app-start') {
          document.body.dispatchEvent(new Event('componentsInTemplateLoaded'));
        }
      }
    },

  });

}());
